// extracted by mini-css-extract-plugin
export default {"container":"Nj-z","bubbleNav":"Oj-z","graphic":"Pj-z","contact":"Qj-z"};